module.exports = __webpack_public_path__ + "static/img/phone-.2dd767d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/phone-.png
// module id = NeaN
// module chunks = 1